// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"MenuList_container__giKmX","placeholder":"MenuList_placeholder__1sAR6"};